import type { DatumId } from "@nivo/pie";

interface GradientConfig {
  activeId: DatumId | null;
  colors: string[];
  seriesKeys: string[];
  type: "bar" | "area";
}

export const createChartGradients = ({
  type,
  seriesKeys,
  colors,
  activeId,
}: GradientConfig) => {
  const gradientPrefix = type === "bar" ? "gradient" : "gradient-area";

  const gradientDefs = seriesKeys.map((key, index) => {
    const isActive = !activeId || activeId === key;

    if (type === "bar") {
      return {
        id: `${gradientPrefix}-${key}`,
        type: "linearGradient" as const,
        colors: [
          {
            offset: 0,
            color: colors[index],
            opacity: isActive ? 1 : 0.5,
          },
          {
            offset: 100,
            color: colors[index],
            opacity: isActive ? 0.4 : 0.2,
          },
        ],
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 1,
      };
    }

    return {
      id: `${gradientPrefix}-${key}`,
      type: "linearGradient" as const,
      colors: [
        {
          offset: 0,
          color: colors[index],
          opacity: isActive ? 0.4 : 0.2,
        },
        {
          offset: 100,
          color: colors[index],
          opacity: 0,
        },
      ],
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 1,
    };
  });

  const fillPattern = seriesKeys.map(key => ({
    match: { id: key },
    id: `${gradientPrefix}-${key}`,
  }));

  return { gradientDefs, fillPattern };
};
